import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../Images/PSYNEXA Logo 3.png";
import { IoClose, IoMenu } from "react-icons/io5";
import { RiArrowDownSLine } from "react-icons/ri";
import "./Navigation.css";
import Button from "./Button";
import { IoIosCall } from "react-icons/io";
import { LuMail } from "react-icons/lu";
import ApointmentForm from "./ApointmentForm";

const Navigtion = () => {
  const [isOpen, setisOpen] = useState(false);
  const [submenu, setsubmenu] = useState(false);

  return (
    <>
      <div className="max-w-[1456px] mx-auto">
        <div className=" bg-white border-b-2 z-50 w-full mx-auto top-0  ">
          <div className="flex items-center justify-around h-[80px]">
            <img src={Logo} className="w-[250px] lg:mx-28" alt="images" />
            <div className="hidden lg:flex lg:mr-10">
              <ul className=" menu flex items-center mr-10 gap-x-7 font-roboto  text-[#1E1E1E] text-xl">
                <li className="hover:text-[#469B8F] ">
                  <Link to={"/Home"}>Home</Link>
                </li>
                <li
                  className="submenuitem hover:text-[#469B8F]"
                  onMouseEnter={() => setsubmenu(true)}
                  onMouseLeave={() => setsubmenu(false)}
                >
                  <Link className="flex items-center " to={"/AboutUs"}>
                    About
                    <RiArrowDownSLine className="text-xl " />
                  </Link>
                  {submenu && (
                    <ul className="menusub  ">
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/Doctor"}>Doctor</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/AboutHospital"}>Psynexa</Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className="submenuitem hover:text-[#469B8F] hover:bg-slate-200]"
                  onMouseEnter={() => setsubmenu(true)}
                  onMouseLeave={() => setsubmenu(false)}
                >
                  <Link className="flex items-center">
                    Condition We Support
                    <RiArrowDownSLine className="text-xl" />
                  </Link>
                  {submenu && (
                    <ul className="menusub ">
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/Mentalillness"}>Mental illness</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/Deaddiction"}>De-addiction</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/Electrotherapy"}>Electrotherapy</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/Epilipsy"}>Epilepsy</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/SexualHelth"}>Sexual Health</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200 ">
                        <Link to={"/Psycotherapy"}>Psycotherapy</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/Child"}>Child guidance</Link>
                      </li>
                      <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                        <Link to={"/geriatric"}>Dementia & Geriatric Care</Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="hover:text-[#469B8F]">
                  <Link to={"/Blog1"}>Blogs</Link>
                </li>

                <li className="hover:text-[#469B8F]">
                  <Link to={"/Photos"}>Gallery</Link>
                </li>
                <li className="hover:text-[#469B8F]">
                  <Link to={"/ContactUs"}>ContactUs</Link>
                </li>
              </ul>
              <Button
                className={
                  "  hover:text-[#469B8F] text-black font-roboto text-[20px] text-center items-center ring-4 ring-[#469B8F] p-1 rounded-full h-[40px] w-[200px]"
                }
                btnName={"Get Appointment"}
                link={"/ContactUs"}
              />
            </div>

            <IoMenu
              className="lg:hidden md:mr-10   flex coursor-pointer"
              fontSize={"40px"}
              onClick={() => setisOpen(true)}
            />
          </div>
          <div className="h-10 flex items-center justify-center md:justify-end md:pr-[40px] md:gap-10  gap-5 content-center bg-gradient-to-r from-[#45998e] to-[#65C0BE]">
            <p className=" flex items-center text-[16px] ">
              <IoIosCall className="pr-2 text-[25px]" /> +91 85758 88887
            </p>
            <p className="flex items-center text-[16px]">
              <LuMail className="pr-2 text-[25px]" />
              Dr.Anant@psynexa.in
            </p>
          </div>
        </div>

        {isOpen && (
          <div
            className="fixed inset-0 bg-black/50 opacity-50 z-40"
            onClick={() => setisOpen(false)}
          ></div>
        )}
        <div
          className={`block lg:hidden shadow-2xl h-screen w-full md:w-[400px]
        ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } fixed top-0 left-0 p-1  bg-[#F7F7F7] transition-transform duration-400 ease-in-out overflow-hidden z-50`}
        >
          <div className="flex items-center justify-between ">
            <img src={Logo} alt="images" className=" w-auto h-auto" />
            <IoClose
              className="text-4xl cursor-pointer"
              onClick={() => setisOpen(false)}
            />
          </div>
          <ul className="font-roboto menu  text-[#1E1E1E] md:text-3xl  sm:text-2xl  items-center py-10 px-3 text-2xl">
            <li className="py-2">
              <Link to={"/Home"} onClick={() => setisOpen(false)}>
                Home
              </Link>
            </li>
            <li
              className="submenuitem flex justify-between hover:text-[#469B8F] py-2 "
              onMouseEnter={() => setsubmenu(true)}
              onMouseLeave={() => setsubmenu(false)}
            >
              <Link to={"/AboutUs"} className=" flex font-roboto item-center ">
                About
              </Link>
              <RiArrowDownSLine className="text-2xl  " />
              {submenu && (
                <ul className="menusub ">
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/Doctor"} onClick={() => setisOpen(false)}>
                      Doctor
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link
                      to={"/AboutHospital"}
                      onClick={() => setisOpen(false)}
                    >
                      Psynexa
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li
              className="submenuitem flex justify-between items-center hover:text-[#469B8F] py-2 "
              onMouseEnter={() => setsubmenu(true)}
              onMouseLeave={() => setsubmenu(false)}
            >
              <Link
                to={"/AboutUs"}
                className=" flex font-roboto  content-center "
              >
                Condition We Support
              </Link>
              <RiArrowDownSLine className="text-2xl  items-end " />
              {submenu && (
                <ul className="menusub  ">
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link
                      to={"/Mentalillness"}
                      onClick={() => setisOpen(false)}
                    >
                      Mental illness
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/Deaddiction"} onClick={() => setisOpen(false)}>
                      De-addiction
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link
                      to={"/Electrotherapy"}
                      onClick={() => setisOpen(false)}
                    >
                      Electrotherapy
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/Epilipsy"} onClick={() => setisOpen(false)}>
                      Epilepsy
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/SexualHelth"} onClick={() => setisOpen(false)}>
                      Sexual Health
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/Psycotherapy"} onClick={() => setisOpen(false)}>
                      Psycotherapy
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/Child"} onClick={() => setisOpen(false)}>
                      Child guidance
                    </Link>
                  </li>
                  <li className="hover:text-[#469B8F] hover:underline hover:bg-slate-200">
                    <Link to={"/geriatric"} onClick={() => setisOpen(false)}>
                      Dementia & Geriatric Care
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className="py-2">
              <Link to={"/Blog1"} onClick={() => setisOpen(false)}>
                Blogs
              </Link>
            </li>
            <li className="py-2">
              <Link to={"/Photos"} onClick={() => setisOpen(false)}>
                Gallery
              </Link>
            </li>
            <li className="py-2">
              <Link to={"/ContactUs"} onClick={() => setisOpen(false)}>
                ContactUs
              </Link>
            </li>
          </ul>
          <Button 
            className={
              "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#469B8F]  rounded-full h-[50px] w-full"
            }
            btnName={"Get Appointment"}
            link={"/ContactUs"}
         
          />
        </div>
      </div>
    </>
  );
};

export default Navigtion;
